import React, {Component} from 'react';

class Form extends Component
{
    submit = (e) => {
        e.preventDefault()
        this.props.action(e)
        return false;
    }

    render() {
        return (
            <form onSubmit={this.submit}>
                {this.props.children}
            </form>
        );
    }
}

Form.defaultProps = {
    action: () => null
};

export default Form;
